import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { from, space } from '@guardian/source/foundations';
import { Column, Columns } from '@guardian/source/react-components';
import { Container } from 'components/layout/container';
import { ObserverLogo } from './ObserverLogo';
import { observerColours } from './styles';
const logoContainer = css `
	display: flex;
	justify-content: center;
	text-decoration: none;
	margin: ${space[6]}px 0 ${space[4]}px 0;

	${from.desktop} {
		margin: ${space[12]}px 0 ${space[8]}px 0;
	}
`;
const logo = css `
	width: 228px;

	${from.desktop} {
		width: 382px;
	}
`;
export default function ObserverHeader() {
    return (_jsx("header", { children: _jsx(Container, { backgroundColor: observerColours.pageBackgroundColor, children: _jsx(Columns, { children: _jsx(Column, { children: _jsx("div", { css: logoContainer, children: _jsx("h1", { css: logo, children: _jsx("a", { href: "https://www.observer.co.uk", children: _jsx(ObserverLogo, {}) }) }) }) }) }) }) }));
}
